"use client";

import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import client from "@/lib/api/client";
import { _ } from "@/lib/api/i18n";

const flagmap: Record<string, string> = {
    BG: "bg",
    "PT-BR": "br",
    ZH: "cn",
    CS: "cz",
    DE: "de",
    DA: "dk",
    ET: "ee",
    ES: "es",
    FI: "fi",
    FR: "fr",
    EL: "gr",
    HU: "hu",
    ID: "id",
    IT: "it",
    JA: "jp",
    KO: "kr",
    LT: "lt",
    LV: "lv",
    NL: "nl",
    NB: "no",
    PL: "pl",
    "PT-PT": "pt",
    RO: "ro",
    RU: "ru",
    AR: "sa",
    SV: "se",
    SL: "si",
    SK: "sk",
    TR: "tr",
    UK: "ua",
    "EN-US": "us",
    "EN-GB": "uk",
};

interface LangPickerProps {
    initial?: string;
    onChange?: (lang: string) => void;
}

export const LangPicker = (props: LangPickerProps) => {
    const [selectedCountry, setSelectedCountry] = useState(props.initial || "EN-US");
    const [langs, setLangs] = useState<{ name: string; lang: string }[]>([]);

    useEffect(() => {
        client.get_languages().then((data: { name: string; lang: string }[]) => setLangs(data || []));
    }, []);

    useEffect(() => {
        props.onChange?.(selectedCountry);
    }, [selectedCountry]);

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                render={
                    <Button variant="ghost" size="sm" className="gap-2" />
                }
            >
                <img
                    alt={flagmap[selectedCountry]}
                    src="/flag_placeholder.png"
                    className={`flag flag-${flagmap[selectedCountry]}`}
                    style={{ width: "2.4rem" }}
                />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="max-h-80 overflow-y-auto">
                {langs.map((l) => (
                    <DropdownMenuItem
                        key={l.lang}
                        onClick={() => setSelectedCountry(l.lang)}
                        className="gap-2 cursor-pointer"
                    >
                        <img
                            alt={l.name}
                            src="/flag_placeholder.png"
                            className={`flag flag-${flagmap[l.lang]}`}
                            style={{ width: "2.4rem" }}
                        />
                        <span>{_(l.name)}</span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
